module.exports = "label {\n  margin-bottom: 0;\n  cursor: pointer; }\n\n.dropdown-toggle {\n  border: none;\n  border-bottom: 1px solid #2196F3; }\n"